"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const OvalIllustrationBottom = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "illustration-oval-bottom" },
            react_1.default.createElement("svg", { className: "illustration-oval-bottom__svg", width: "248", height: "200", viewBox: "0 0 248 200", fill: "none" },
                react_1.default.createElement("g", { clipPath: "url(#clip0_1884_112699)" },
                    react_1.default.createElement("rect", { width: "38.871", height: "208.26", rx: "19.4355", transform: "matrix(-0.866395 -0.499359 -0.500641 0.865655 50.9409 134.14)", fill: "#17C873" }),
                    react_1.default.createElement("rect", { width: "38.871", height: "38.2193", rx: "19.1097", transform: "matrix(-0.866395 -0.499359 -0.500641 0.865655 81.689 86.2725)", fill: "#17C873" }),
                    react_1.default.createElement("rect", { width: "105.928", height: "328.195", rx: "52.9639", transform: "matrix(-0.866395 -0.499359 -0.500641 0.865655 248 69.896)", fill: "#B1E2FD" })),
                react_1.default.createElement("defs", null,
                    react_1.default.createElement("clipPath", { id: "clip0_1884_112699" },
                        react_1.default.createElement("rect", { width: "248", height: "200", fill: "white" })))))));
};
exports.default = OvalIllustrationBottom;
